import DOMPurify from "dompurify";

// DOMPurify's build exports a ready instance when a global `window`
// exists (the browser and the jsdom test env), or a factory when it
// does not. Normalize to an instance so this works in both.
const win = typeof window !== "undefined" ? window : undefined;
const purify = typeof DOMPurify.sanitize === "function"
	? DOMPurify
	: DOMPurify(win);

/**
 * Sanitize user-authored rich text (the ProseMirror HTML stored on
 * Entry.text and Comment.text) before it is rendered with v-html.
 * Strips script tags, event-handler attributes and other XSS vectors
 * while keeping the editor's formatting tags. A nullish value yields
 * an empty string.
 */
export function sanitizeHtml(dirty) {
	if (dirty === undefined || dirty === null) return "";
	return purify.sanitize(String(dirty));
}
